import React from 'react';
import { Button, ButtonProps, styled } from '@mui/material';

interface StyledChooseFileButtonProps extends ButtonProps {
  children?: React.ReactNode;
}

const StyledChooseFileButton = styled(Button)<StyledChooseFileButtonProps>(
  ({ theme }) => ({
    fontWeight: 400,
    '&.MuiButtonBase-root': {
      backgroundColor: 'white',
      color: theme.palette.grey[400],
      textTransform: 'capitalize',
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      '&:hover': {
        textDecoration: 'underline',
        boxShadow: 'none',
      },
      '&:active': {
        backgroundColor: theme.palette.grey[100],
      },
      '&.Mui-disabled': {
        backgroundColor: theme.palette.action.disabledBackground,
        color: theme.palette.text.disabled,
      },
    },
  }),
);

const ChooseFileButton: React.FC<StyledChooseFileButtonProps> = ({
  children = 'Choose File',
  ...props
}) => {
  return <StyledChooseFileButton {...props}>{children}</StyledChooseFileButton>;
};

export default ChooseFileButton;
